import React from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  return (
    <div className="layout-root bg-gray-900 text-white min-h-screen flex flex-col lg:flex-row">
      <Sidebar />
      <main className="main-content-scroll flex-1 lg:ml-[12.8rem] mb-1">
        {children}
      </main>
    </div>
  );
};

export default Layout;